'use client'
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/footer.ts
var FOOTER_QUERY = `
logo {
  ${IMAGE_QUERY}
}
downloadAppPrompt
mobileAppLinksCollection {
  items {
    ${LINK_QUERY}
  }
}
bottomLinksCollection {
  items {
    ${LINK_QUERY}
  }
}
copyrightText
govLicenseTitle
companyName
tourismLicenseNumber
govLicenseCategory
crNumber
vatNumber
supportedPayments
sponsorsCollection(limit: 10) {
  items {
    id
    title
    sponsorsCollection(limit: 10) {
      items {
        id
        title
        logo {
          ${IMAGE_QUERY}
        }
        link
      }
    }
  }
}
`;

export {
  FOOTER_QUERY
};
//# sourceMappingURL=chunk-5PELS77M.mjs.map